import MapMapbox from './MapMapbox';

export default MapMapbox;
